/**
 * Break-glass: the row that holds the quote sort control.
 *
 * Its right edge has to line up with the quote cards below it, which means
 * matching RevealBox's 1152px cap exactly and opting out of the centring the
 * surrounding column applies (`self-start` — without it a capped child gets
 * centred and drifts off the cards' left edge). Neither an arbitrary cap that
 * mirrors a sibling nor a per-child alignment override has a ui-core primitive.
 */

import type { ReactNode } from "react";

interface BookShipmentQuoteSortRowProps {
  children: ReactNode;
}

export function BookShipmentQuoteSortRow({
  children,
}: BookShipmentQuoteSortRowProps) {
  return (
    <div className="flex w-full max-w-[1152px] flex-row justify-end self-start">
      {children}
    </div>
  );
}
